import React from "react";
import { Avatar } from "antd";

const AvatarComponent = (props) => {
  const { record, text } = props;
  const letter = record.first_name.charAt(0);
  return text ? (
    <Avatar src={text} />
  ) : (
    <Avatar style={{ color: "#f56a00", backgroundColor: "#fde3cf" }}>
      {letter}
    </Avatar>
  );
};

export default AvatarComponent;
